<template>
  <div class="p-box">
    <div class="p-box__body">
      <p>{{ $t('pages.CompaniesProductNew.selectedStores') }}：<span class="select-store">{{ $tc('pages.CompaniesProductNew.storesCount', selectedStoreCount) }}</span></p>

      <div class="c-button c-button--icon">
        <button
          class="c-button__item c-button__item--primary"
          type="button"
          @click="$emit('open-store-modal')"
        >
          <Icon name="iconPlusRed" />

          {{ $t('pages.CompaniesProductNew.selectStores') }}
        </button>
      </div>

      <slot />
    </div>
  </div>
</template>

<script>
import Icon from '../../components/Icon.vue'

export default {
  name: 'SelectStore',
  components: {
    Icon
  },
  props:{
    selectedStoreCount: {
      type: Number,
      default: 0
    },
  },
  emits: ['open-store-modal']
}
</script>

<style lang="scss" scoped>
.select-store {
  font-weight: bold;
}
</style>
